import { AppModal } from './Modals';
export default AppModal;
